import { Layout } from 'antd';
import { Outlet } from 'react-router';

const { Content } = Layout;

export const PublicLayout = () => {
  return (
    <Layout className="min-h-screen">
      <Content className="flex items-center justify-center bg-gray-50">
        <Outlet />
      </Content>
    </Layout>
  );
};
